import { render } from "./Footer.vue?vue&type=template&id=5061971b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5061971b&scoped=true&lang=css"

import exportComponent from "D:\\dig\\dig-web\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5061971b"]])

export default __exports__